import { config } from '@/config/app.config';

export const operationModeTimeInSec = config.mip.operationModeTimeInSec;

export const getOperationModeTimeInHours = (): number => (Math.round(operationModeTimeInSec / 60 / 60) * 1000) / 1000;
